import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import QuestionType from '@/models/Questions/QuestionType';
import QuestionChoiceDto from '@/models/QuestionChoices/QuestionChoiceDto';

export default class UpdateQuestionRequest extends BaseUpdateRequest {
    title = '';    
    body = '';
}